import React from 'react';
import SectionMessage from '@atlaskit/section-message';

import { OptionDisabledWarningWrapper as Wrapper } from './styles';

const SECTION_TITLE = 'This is the last level';

const renderMessage = () => 'Currently, our app supports only 7 levels (due to technical limitations). Therefore, "Options" is not available.';

const LastLevelInfoMessage: React.FC = () => (
    <Wrapper>
        <SectionMessage title={SECTION_TITLE} appearance="information">
            <p>{renderMessage()}</p>
        </SectionMessage>
    </Wrapper>
);

export default LastLevelInfoMessage;
